import React, { useState, useEffect } from "react";
import SideMenu from "../../Components/SideMenu/SideMenu";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import cssClasses from "./MainPage.module.css";
import { Outlet } from "react-router-dom";
// import NotificationsIcon from '../../Assets/Images/SideMenuIcons/Notifications.svg';
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "../../Components/Icons/Bell";
import { signOut } from "../../Services/LoginService";
import { errorTost, offlineToast } from "../../Services/Toast";
import action from "../../Redux Store/actions";
import * as actionTypes from "../../Redux Store/actionType/action-type";
import store from "../../Redux Store/store";
import { useNavigate, useLocation } from "react-router-dom";
import { Badge, SwipeableDrawer, Tooltip } from "@mui/material";
import NotificationDrawer from "../../Modals/NotificationDrawer/NotificationDrawer";
import { supabase } from "../../supabaseClient";
// import { useNavigate, useLocation } from "react-router-dom";

import { getLatestCPData, getLatestFOSData } from "../../Services/LoginService";
// ? keyboard to listen when keyboard shows/hides & hide/show mobile menu respectively
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";
import { useDispatch, useSelector } from "react-redux";
import { Network } from "@capacitor/network";
const drawerWidth = "20%";

function MainPage(props) {
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.Auth.user);

  const [isNotificationShow, setIsNotificationShow] = useState(false);
  const [eventNotificationCount, setEventNotificationCount] = useState(0);
  const [leadNotificationCount, setLeadNotificationCount] = useState(0);
  const [fosNotificationCount, setFosNotificationCount] = useState(0);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  // const [profileData, setProfileData] = useState(loggedInUser);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div style={{ height: "100%" }}>
      <SideMenu
        props={(v) => {
          setMobileOpen(v);
        }}
      />
    </div>
  );
  // useEffect(() => {
  //   console.log({loggedInUser});
  //   setProfileData(loggedInUser);
  // }, [loggedInUser])

  const container =
    window1 !== undefined ? () => window().document.body : undefined;
  function logoutUser() {
    signOut()
      .then(({ err }) => {
        if (err) {
          errorTost(err);
        } else {
          store.dispatch(action.authLogout());
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      })
      .catch((error) => {
        errorTost(error);
      });
  }
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener("keyboardWillShow", (e) => {
        // console.log("keyboard will show, hiding bottom menu....");
        setKeyboardOpen(true);
      });
      Keyboard.addListener("keyboardDidHide", (e) => {
        // console.log("keyboard hidden, showing bottom menu....");
        setKeyboardOpen(false);
      });
    }
    return () => {
      if (Capacitor.isNativePlatform()) {
        Keyboard.removeAllListeners();
      }
    };
  }, []);
  useEffect(() => {
    let eventNotificationsListener = null;
    let leadNotificationsListener = null;
    let fosNotificationsListener = null;
    if (loggedInUser) {
      // console.log("loggedInUser => ", loggedInUser);

      Network.getStatus().then((netWorkResponse) => {
        if (netWorkResponse.connected) {
          if (!eventNotificationsListener) {
            eventNotificationsListener = supabase
              .from(
                `${loggedInUser.type === "CP"
                  ? "EventNotificationsForCp"
                  : "EventNotificationsForFos"
                }:${loggedInUser.type === "CP" ? "cpId" : "fosId"}=eq.${loggedInUser.type === "CP"
                  ? loggedInUser.cpId
                  : loggedInUser.fosId
                }`
              )
              .on("INSERT", (payload) => {
                // console.log("Change received!", payload);
                if (payload.eventType === "INSERT") {
                  setEventNotificationCount((pre) => pre + 1);
                }
              })
              .subscribe((status, r) => {
                // console.log({ status, r });
                if (status === "SUBSCRIBED") {
                  supabase
                    .from(
                      `${loggedInUser.type === "CP"
                        ? "EventNotificationsForCp"
                        : "EventNotificationsForFos"
                      }`
                    )
                    .select("*", { count: "exact" })
                    .eq(
                      loggedInUser.type === "CP" ? "cpId" : "fosId",
                      loggedInUser.type === "CP"
                        ? loggedInUser.cpId
                        : loggedInUser.fosId
                    )
                    .eq("isRead", false)
                    .then((res) => {
                      // console.log(
                      //   `${
                      //     loggedInUser.type === "CP"
                      //       ? "EventNotificationsForCp"
                      //       : "EventNotificationsForFos"
                      //   }`,
                      //   res
                      // );
                      if (res.data && res.count) {
                        setEventNotificationCount((pre) => pre + res.count);
                      }
                    });
                }
              });
          }

          if (!leadNotificationsListener) {
            leadNotificationsListener = supabase
              .from(
                `${loggedInUser.type === "CP"
                  ? "LeadNotificationsForCp"
                  : "LeadNotificationsForFos"
                }:${loggedInUser.type === "CP" ? "cpId" : "fosId"}=eq.${loggedInUser.type === "CP"
                  ? loggedInUser.cpId
                  : loggedInUser.fosId
                }`
              )
              .on("INSERT", (payload) => {
                // console.log("Change received!", payload);
                if (payload.eventType === "INSERT") {
                  setLeadNotificationCount((pre) => pre + 1);
                }
              })
              .subscribe((status, r) => {
                // console.log({ status, r });
                if (status === "SUBSCRIBED") {
                  supabase
                    .from(
                      `${loggedInUser.type === "CP"
                        ? "LeadNotificationsForCp"
                        : "LeadNotificationsForFos"
                      }`
                    )
                    .select("*", { count: "exact" })
                    .eq(
                      loggedInUser.type === "CP" ? "cpId" : "fosId",
                      loggedInUser.type === "CP"
                        ? loggedInUser.cpId
                        : loggedInUser.fosId
                    )
                    .eq("isRead", false)
                    .then((res) => {
                      // console.log(
                      //   `${
                      //     loggedInUser.type === "CP"
                      //       ? "LeadNotificationsForCp"
                      //       : "LeadNotificationsForFos"
                      //   }`,
                      //   res
                      // );
                      if (res.data && res.count) {
                        setLeadNotificationCount((pre) => pre + res.count);
                      }
                    });
                }
              });
          }

          if (
            !fosNotificationsListener &&
            loggedInUser.type === "CP" &&
            loggedInUser.cpType === "Entity"
          ) {
            fosNotificationsListener = supabase
              .from(
                `FosNotifications:${loggedInUser.type === "CP" ? "cpId" : "fosId"
                }=eq.${loggedInUser.type === "CP"
                  ? loggedInUser.cpId
                  : loggedInUser.fosId
                }`
              )
              .on("INSERT", (payload) => {
                // console.log("Change received!", payload);
                if (payload.eventType === "INSERT") {
                  setFosNotificationCount((pre) => pre + 1);
                }
              })
              .subscribe((status, r) => {
                // console.log({ status, r });
                if (status === "SUBSCRIBED") {
                  supabase
                    .from(`FosNotifications`)
                    .select("*", { count: "exact" })
                    .eq(
                      loggedInUser.type === "CP" ? "cpId" : "fosId",
                      loggedInUser.type === "CP"
                        ? loggedInUser.cpId
                        : loggedInUser.fosId
                    )
                    .eq("isRead", false)
                    .then((res) => {
                      // console.log(`FosNotifications`, res);
                      if (res.data && res.count) {
                        setFosNotificationCount((pre) => pre + res.count);
                      }
                    });
                }
              });
          }
        }
      });
    }

    return () => {
      if (eventNotificationsListener) {
        supabase.removeSubscription(eventNotificationsListener);
        eventNotificationsListener = null;
      }
      if (leadNotificationsListener) {
        supabase.removeSubscription(leadNotificationsListener);
        leadNotificationsListener = null;
      }
      if (fosNotificationsListener) {
        supabase.removeSubscription(fosNotificationsListener);
        fosNotificationsListener = null;
      }
      Network.removeAllListeners();
    };
  }, [loggedInUser]);

  useEffect(() => {
    console.log("calling");
    if (loggedInUser) {
      if (loggedInUser.type === "CP") {
        getLatestCPDataFun(loggedInUser.cpId);
      } else if (loggedInUser.type === "FOS") {
        getLatestFOSDataFun(loggedInUser.fosId, loggedInUser.cpId);
      }
    }
  }, []);

  useEffect(() => {
    console.log(loggedInUser.cpId);
    if (loggedInUser) {
      let updateStatusListenerForCP;
      updateStatusListenerForCP = supabase
        .from(`CP:cpId=eq.${loggedInUser.cpId}`)
        .on("UPDATE", (handleRecordUpdated) => {
          console.log({ handleRecordUpdated });
          if (handleRecordUpdated.new.cpId !== loggedInUser.cpId) {
            if (updateStatusListenerForCP) {
              supabase.removeSubscription(updateStatusListenerForCP);
              updateStatusListenerForCP = null;
              updateStatusListenerForCP = supabase
                .from(`CP:cpId=eq.${loggedInUser.cpId}`)
                .on("UPDATE", (handleRecordUpdated) => {
                  cpSubscriber(handleRecordUpdated);
                })
                .subscribe();
            }
          } else {
            cpSubscriber(handleRecordUpdated);
          }
        })
        .subscribe();
      //to listened FOS changes
      if (loggedInUser?.fosId) {
        let updateStatusListenerForFos = supabase
          .from(`FOS:fosId=eq.${loggedInUser.fosId}`)
          .on("UPDATE", (handleRecordUpdated) => {
            console.log({ handleRecordUpdated });
            if (handleRecordUpdated.new.approvalStatus === "rejected") {
              // if (location.pathname.includes("/Home/Profile") === false) {
              navigate("/Home/Profile");
              // }
              errorTost("You are rejected. Contact your admin");
              // setProfileData((pre) => {
              //   pre.approvalStatus = handleRecordUpdated.new.approvalStatus;
              //   pre.rejectionReason= handleRecordUpdated.new.rejectionReason;
              //   pre.cpId=handleRecordUpdated.new.cpId;
              //   return { ...pre };
              // });
              dispatch(
                action.authLogin({
                  ...loggedInUser,
                  approvalStatus: handleRecordUpdated.new.approvalStatus,
                  rejectionReason: handleRecordUpdated.new.rejectionReason,
                })
              );
            } else {
              dispatch(
                action.authLogin({
                  ...loggedInUser,
                  approvalStatus: handleRecordUpdated.new.approvalStatus,
                  rejectionReason: handleRecordUpdated.new.rejectionReason,
                })
              );
            }
          })
          .subscribe((status) => {
            console.log("status: ", status);
          });
        return () => {
          if (updateStatusListenerForFos) {
            supabase.removeSubscription(updateStatusListenerForFos);
            updateStatusListenerForFos = null;
          }
        };
      }
      return () => {
        if (updateStatusListenerForCP) {
          supabase.removeSubscription(updateStatusListenerForCP);
          updateStatusListenerForCP = null;
        }
      };
    }
  }, [loggedInUser]);
  function cpSubscriber(handleRecordUpdated) {
    if (handleRecordUpdated.new.approvalStatus === "rejected") {
      // if (location.pathname.includes("/Home/Profile") === false) {
      navigate("/Home/Profile");
      // }
      if (loggedInUser?.fosId) {
        errorTost("Your CPE has been rejected!");
      } else {
        errorTost(
          "You are rejected. Contact your VJ Sales Admin for more details!"
        );
      }
    }
    //Fos is logged in to update their CP's status only
    if (loggedInUser.fosId) {
      // setProfileData((pre) => {
      //   pre.cpData.approvalStatus =
      //     handleRecordUpdated.new.approvalStatus;
      //   return { ...pre };
      // });
      let cpData = loggedInUser.cpData;
      cpData.approvalStatus = handleRecordUpdated.new.approvalStatus;
      dispatch(action.authLogin({ ...loggedInUser, cpData: cpData }));
    } else {
      //Update CP details
      dispatch(
        action.authLogin({
          ...loggedInUser,
          approvalStatus: handleRecordUpdated.new.approvalStatus,
          rejectionReason: handleRecordUpdated.new.rejectionReason,
        })
      );
    }
  }
  function getLatestCPDataFun(cpId) {
    getLatestCPData(cpId).then((resp) => {
      console.log({ ...resp, ...resp.cpId, type: loggedInUser.type });
      console.log(resp);
      if (
        resp.cpId.approvalStatus === "rejected" ||
        resp.cpId.approvalStatus === "resubmitted"
      ) {
        console.log(resp.approvalStatus);
        navigate("/Home/Profile");
      }
      dispatch(
        action.authLogin({ ...resp, ...resp.cpId, type: loggedInUser.type })
      );
    });
  }
  function getLatestFOSDataFun(fosId, cpId) {
    getLatestFOSData(fosId, cpId).then((resp) => {
      console.log("fosResp", resp);
      console.log({
        ...resp,
        cpData: resp.cpId,
        cpId: resp.cpId ? resp.cpId.cpId : null,
        type: loggedInUser.type,
      });
      if (resp.cpId?.approvalStatus === "approved") {
        if (
          resp.approvalStatus === "rejected" ||
          resp.approvalStatus === "resubmitted"
        ) {
          navigate("/Home/Profile");
        }
      } else {
        navigate("/Home/Profile");
      }
      dispatch(
        action.authLogin({
          ...resp,
          cpData: resp.cpId,
          cpId: resp.cpId ? resp.cpId.cpId : null,
          type: loggedInUser.type,
        })
      );
    });
  }
  return (
    <>
      <Box
        sx={{ display: "flex" }}
        style={{
          height: "100%",
          flexDirection: window.innerWidth <= 820 ? "column" : "",
        }}
      >
        {window.innerWidth > 820 && (
          <>
            <CssBaseline />
            {/* <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        > */}

            <Toolbar
              className={cssClasses.wrapperMenu}
              sx={{
                width:
                  window.innerWidth > 820
                    ? { sm: `calc(100% - ${drawerWidth}px)` }
                    : `100%`,
                ml: { sm: `${drawerWidth}px` },
                alignItems: "flexStart !important",
                // position:'fixed'
              }}
            >
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
              // sx={{ mr: 2, display: { sm: 'none' } }}
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
            {/* </AppBar> */}
            <Box
              component="nav"
              sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
              aria-label="mailbox folders"
              style={{ height: "100%" }}
            >
              {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
              <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: "block", sm: "none" },
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: "44%",
                  },
                }}
              >
                {drawer}
              </Drawer>
              <Drawer
                variant="permanent"
                sx={{
                  display: { xs: "none", sm: "block" },
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                  },
                }}
                open
              >
                {drawer}
              </Drawer>
            </Box>
          </>
        )}
        <Box
          display={"flex"}
          flexDirection={"column"}
          // component="main"
          sx={{
            flexGrow: 1,
            width: "100%",
            height:
              window.innerWidth > 820 ? "100%" : keyboardOpen ? "100%" : "90%",
            padding: 0,
          }}
        >
          <Box
            display={"flex"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            // height={'5%'}
            sx={{
              padding: "1.5rem 3rem 0",
            }}
          >
            {/* <img src={NotificationsIcon} alt="Notifications" /> */}
            {!location.pathname.toLowerCase().includes("/home/foswallet") && (
  <Tooltip
    title={<p style={{ fontSize: "1.4rem" }}>Notifications</p>}
    arrow
  >
    <IconButton
      onClick={() => {
        if (
          (loggedInUser?.type === "FOS" &&
            loggedInUser?.cpData?.approvalStatus === "approved" &&
            loggedInUser?.approvalStatus === "approved") ||
          (loggedInUser?.type === "CP" &&
            loggedInUser?.approvalStatus === "approved")
        ) {
          Network.getStatus().then((netWorkResponse) => {
            if (netWorkResponse.connected) {
              setIsNotificationShow(true);
            } else {
              offlineToast();
            }
          });
        } else {
          if (
            loggedInUser?.fosId &&
            loggedInUser?.cpData?.approvalStatus === "rejected"
          ) {
            errorTost("Your CPE has been rejected!");
          } else if (
            loggedInUser?.fosId &&
            loggedInUser?.approvalStatus === "rejected"
          ) {
            errorTost("You are rejected. Contact your CP for more details!");
          } else if (
            loggedInUser?.cpId &&
            loggedInUser?.approvalStatus === "rejected"
          ) {
            errorTost("You are rejected. Contact your VJ Sales Admin for more details!");
          }
        }
      }}
    >
      {eventNotificationCount + leadNotificationCount + fosNotificationCount === 0 ? (
        <NotificationsIcon
          width={window.innerWidth === 820 ? "4rem" : "3rem"}
          height={window.innerWidth === 820 ? "4rem" : "3rem"}
          className={cssClasses.logoutIcon}
        />
      ) : (
        <Badge
          badgeContent={
            eventNotificationCount +
            leadNotificationCount +
            fosNotificationCount
          }
          color="primary"
          sx={{
            ".MuiBadge-badge": {
              fontSize: "1.4rem",
            },
          }}
        >
          <NotificationsIcon
            width={window.innerWidth === 820 ? "4rem" : "3rem"}
            height={window.innerWidth === 820 ? "4rem" : "3rem"}
            className={cssClasses.logoutIcon}
          />
        </Badge>
      )}
    </IconButton>
  </Tooltip>
)}

            {/* helpDesk */}
            {/* <Tooltip
              title={<p style={{ fontSize: "1.4rem" }}>HelpDesk</p>}
              arrow
            >
              <button
                onClick={() => {
                  dispatch({
                    type: actionTypes.ACTIVE_MENU,
                    payload: "support",
                  });
                  navigate("/Home/Support");
                }}
                style={{
                  fontSize: "1.4rem",
                  padding: "0.6rem 1.2rem",
                  borderRadius: "4px",
                  backgroundColor: "#1570EF",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                HelpDesk
              </button>
            </Tooltip> */}

            {window.innerWidth <= 820 && (
              <LogoutIcon
                className={cssClasses.logoutIcon}
                onClick={logoutUser}
              />
            )}
          </Box>
          <Box
            flex={1}
            sx={{
              overflowY:
                location.pathname.includes("Support") ||
                location.pathname.includes("ticket-history")
                  ? "auto"
                  : "hidden",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <Outlet />
          </Box>
        </Box>
        {window.innerWidth <= 820 && (
          <SideMenu
            props={(v) => {
              setMobileOpen(v);
            }}
          />
        )}
      </Box>
      <SwipeableDrawer
        anchor={"right"}
        open={isNotificationShow}
        onClose={() => setIsNotificationShow(false)}
        onOpen={() => setIsNotificationShow(true)}
        sx={{
          " .MuiDrawer-paper": {
            width: {
              xs: "100%",
              sm: "70rem",
              md: "70rem",
              lg: "70rem",
              xl: "70rem",
            },
          },
        }}
      >
        {/* {list(anchor)} */}
        {/* <div style={{width: "200px", height: "500px", background: "red"}}>
          ssssssssss
        </div> */}
        {isNotificationShow && (
          <NotificationDrawer
            toggleDrawer={(_value) => setIsNotificationShow(_value)}
            clearEventNotification={() => {
              setEventNotificationCount(0);
            }}
            clearLeadNotification={() => {
              setLeadNotificationCount(0);
            }}
            clearFosNotification={() => {
              setFosNotificationCount(0);
            }}
            countObject={{
              eventNotificationCount,
              leadNotificationCount,
              fosNotificationCount,
            }}
          />
        )}
      </SwipeableDrawer>
    </>
  );
}
export default MainPage;
